import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Button, Icon } from "semantic-ui-react";
import "../styles/SaveButton.less";
import PropTypes from "prop-types";

@observer
class SaveButton extends Component {
  render() {
    const { t, tReady, ...rest } = this.props;
    return (
      <Button className="tour-save-btn" primary icon type="submit" {...rest}>
        <Icon name="save" />
        &nbsp;{t("saveTour")}
      </Button>
    );
  }
}

SaveButton.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool,
};

export default withTranslation()(SaveButton);
